__turbopack_context__.v({
  "addAssigneeButton": "kPrxMG_addAssigneeButton",
  "addTaskButton": "kPrxMG_addTaskButton",
  "allocationsColumnsHeader": "kPrxMG_allocationsColumnsHeader",
  "allocationsTotalBadge": "kPrxMG_allocationsTotalBadge",
  "assigneeAvatars": "kPrxMG_assigneeAvatars",
  "deliverableCard": "kPrxMG_deliverableCard",
  "deliverableCardHeader": "kPrxMG_deliverableCardHeader",
  "deliverableExpanded": "kPrxMG_deliverableExpanded",
  "deliverableHeaderActions": "kPrxMG_deliverableHeaderActions",
  "deliverableMeterCard": "kPrxMG_deliverableMeterCard",
  "deliverableMeterHeader": "kPrxMG_deliverableMeterHeader",
  "deliverableMeterLabel": "kPrxMG_deliverableMeterLabel",
  "deliverableMeterLegend": "kPrxMG_deliverableMeterLegend",
  "deliverableMeterNumbers": "kPrxMG_deliverableMeterNumbers",
  "deliverableMeterSummary": "kPrxMG_deliverableMeterSummary",
  "deliverableMetersGroup": "kPrxMG_deliverableMetersGroup",
  "deliverableMetersRow": "kPrxMG_deliverableMetersRow",
  "deliverableMetricsStrip": "kPrxMG_deliverableMetricsStrip",
  "deliverableMetricsStripCompact": "kPrxMG_deliverableMetricsStripCompact",
  "deliverableName": "kPrxMG_deliverableName",
  "deliverableTaskSubRowForm": "kPrxMG_deliverableTaskSubRowForm",
  "deliverableTaskSubRowFormRow": "kPrxMG_deliverableTaskSubRowFormRow",
  "deliverableTaskSubRowStatus": "kPrxMG_deliverableTaskSubRowStatus",
  "deliverableTasksTable": "kPrxMG_deliverableTasksTable",
  "detailHint": "kPrxMG_detailHint",
  "detailTitle": "kPrxMG_detailTitle",
  "detailValue": "kPrxMG_detailValue",
  "editAllocationActionsCell": "kPrxMG_editAllocationActionsCell",
  "editAllocationAssigneeCell": "kPrxMG_editAllocationAssigneeCell",
  "editAllocationAssigneePreview": "kPrxMG_editAllocationAssigneePreview",
  "editAllocationMetricsCell": "kPrxMG_editAllocationMetricsCell",
  "editAllocationRow": "kPrxMG_editAllocationRow",
  "expandChevron": "kPrxMG_expandChevron",
  "expandChevronOpen": "kPrxMG_expandChevronOpen",
  "expandToggleButton": "kPrxMG_expandToggleButton",
  "hybridEmpty": "kPrxMG_hybridEmpty",
  "hybridPanel": "kPrxMG_hybridPanel",
  "hybridPanelActions": "kPrxMG_hybridPanelActions",
  "hybridPanelHeader": "kPrxMG_hybridPanelHeader",
  "hybridPanelTitleGroup": "kPrxMG_hybridPanelTitleGroup",
  "hybridStripControl": "kPrxMG_hybridStripControl",
  "inlineAllocationRow": "kPrxMG_inlineAllocationRow",
  "inlineAllocationsHeader": "kPrxMG_inlineAllocationsHeader",
  "inlineAllocationsRows": "kPrxMG_inlineAllocationsRows",
  "inlineAllocationsTitle": "kPrxMG_inlineAllocationsTitle",
  "inlineCreateActions": "kPrxMG_inlineCreateActions",
  "inlineCreateError": "kPrxMG_inlineCreateError",
  "inlineMetaButton": "kPrxMG_inlineMetaButton",
  "inlineMetaMenu": "kPrxMG_inlineMetaMenu",
  "inlineMetaPicker": "kPrxMG_inlineMetaPicker",
  "inlineMetaSelect": "kPrxMG_inlineMetaSelect",
  "inlineTaskCreateForm": "kPrxMG_inlineTaskCreateForm",
  "inlineTaskTitleCell": "kPrxMG_inlineTaskTitleCell",
  "legendFill": "kPrxMG_legendFill",
  "legendStripe": "kPrxMG_legendStripe",
  "legendTick": "kPrxMG_legendTick",
  "metricCard": "kPrxMG_metricCard",
  "moveTaskCurrentLocation": "kPrxMG_moveTaskCurrentLocation",
  "moveTaskDrawer": "kPrxMG_moveTaskDrawer",
  "moveTaskDrawerBody": "kPrxMG_moveTaskDrawerBody",
  "moveTaskDrawerFooter": "kPrxMG_moveTaskDrawerFooter",
  "moveTaskDrawerHeader": "kPrxMG_moveTaskDrawerHeader",
  "moveTaskDrawerTitle": "kPrxMG_moveTaskDrawerTitle",
  "moveTaskLabel": "kPrxMG_moveTaskLabel",
  "moveTaskModeButton": "kPrxMG_moveTaskModeButton",
  "moveTaskModeButtonActive": "kPrxMG_moveTaskModeButtonActive",
  "moveTaskModeGroup": "kPrxMG_moveTaskModeGroup",
  "moveTaskValue": "kPrxMG_moveTaskValue",
  "poolHeader": "kPrxMG_poolHeader",
  "poolRow": "kPrxMG_poolRow",
  "poolTable": "kPrxMG_poolTable",
  "poolTotalRow": "kPrxMG_poolTotalRow",
  "taskChatCell": "kPrxMG_taskChatCell",
  "taskDescriptionCell": "kPrxMG_taskDescriptionCell",
  "taskLoeCell": "kPrxMG_taskLoeCell",
  "taskNameCell": "kPrxMG_taskNameCell",
  "taskNameMeta": "kPrxMG_taskNameMeta",
  "taskNameText": "kPrxMG_taskNameText",
  "taskPlaceholderCell": "kPrxMG_taskPlaceholderCell",
  "taskReadonlyStatus": "kPrxMG_taskReadonlyStatus",
  "taskServiceTypeCell": "kPrxMG_taskServiceTypeCell",
  "tasksPage": "kPrxMG_tasksPage",
  "tasksPageLoading": "kPrxMG_tasksPageLoading",
  "tasksTitle": "kPrxMG_tasksTitle",
  "tasksTopBar": "kPrxMG_tasksTopBar",
});
